import { useEffect, useState } from "react";
import { FilterState } from "./Filters";
import SteelcaseRefinementList from "./SteelcaseRefinementList";
import { useCurrentRefinements } from "react-instantsearch";

interface FilterDropdownProps extends FilterState {
    toggleDropdown: (node: HTMLDivElement | null, id: number) => void;
    toggleDropdownHandler: (id: number) => void;
    isMobile: boolean;
}

export default function FilterDropdown({ id, filters, isOpen, toggleDropdown, toggleDropdownHandler, isMobile }: FilterDropdownProps) {

    const [count, setCount] = useState(0);
    
    const [selectedItemsCount, setSelectedItemsCount] = useState(0);
    const [attrCount, setAttrCount] = useState<{ [key: string]: number}>({});

    const handleApplyAllFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setCount((prevCount) => prevCount + 1);
        toggleDropdownHandler(id);
    }

    const handleSelectedItemsCount = (filterAttr: string, filterCount: number) => {
        setAttrCount((prevAttrs) => {
            const newAttrs = { ...prevAttrs };
            newAttrs[filterAttr] = filterCount
            return newAttrs;
        });
        
    }

    useEffect(() => {
        let count = 0;
        Object.entries(attrCount).forEach(item => {
            count += item[1]
        })
        setSelectedItemsCount(count)   
    }, [attrCount])

    return (
        <>
        {
            filters.length < 3 ?
                <div key={id} ref={(node) => toggleDropdown(node, id)} className={`${isOpen ? "" : "finish-filters-dropdown--hide"} finish-filters-dropdown finish-filters-dropdown__container`}>
                    <div>
                            <div className={`${filters.length > 1 && "finish-filters-dropdown__container--two-col"}`}>
                            {
                                filters.map((item, idx) => {
                                    return (
                                        <section key={idx}>
                                            <h3 className={`finish-filters-dropdown__heading`}>{item.filterName}</h3>
                                            <div className={`${item.filterAttr === "filters.price" ? "finish-filters-modal__filter-section-vertical-grid": "finish-filters-modal__filter-section-grid"}`}>
                                                <SteelcaseRefinementList 
                                                    key={item.filterName} 
                                                    filterName={item.filterName} 
                                                    showHeading={false} 
                                                    filterAttr={item.filterAttr} 
                                                    count={count} 
                                                    searchable={item.searchable} 
                                                    limit={item.limit}
                                                    sort={item.sort}
                                                    pinnedItems={item.pinnedItems}
                                                    sortItems={item.sortItems}
                                                    sortItemCriteria={item.sortItemCriteria}
                                                    placeholderText={item.placeholderText} 
                                                    setApplyCount={handleSelectedItemsCount} 
                                                    isMobile={isMobile} 
                                                />
                                            </div>
                                        </section>
                                    )
                                })
                            }   
                            </div>
                            <div className={"finish-filters--flex"}>
                                <button
                                    className={"finish-filters__button finish-filters__button--primary"}
                                    onClick={(event) => handleApplyAllFilters(event)}
                                >
                                    {window.steelcase_i18n['steelcase-finish-library'].filters.apply || "Apply"} { selectedItemsCount && selectedItemsCount > 0 ? `${selectedItemsCount}+ ${window.steelcase_i18n["steelcase-finish-library"].materials || "MATERIALS"}` : ""} 
                                </button>
                            </div>
                    </div>
                </div>
            :
            <div className={`finish-filters-modal__container ${isOpen ? "finish-filters-modal__container--show" : ""}`}>
                <div ref={(node) => toggleDropdown(node, id)} className={`finish-filters-modal__card`}>
                    <div className={`finish-filters-modal__content`}>
                        <h1 className={`finish-filters-modal__heading`}>{( window.steelcase_i18n["steelcase-finish-library"].more_filters === "More filterss" ? "More Filters" : window.steelcase_i18n["steelcase-finish-library"].more_filters) || "More Filters"}</h1>
                        <div className={`finish-filters-modal__scrollable-area`}>
                            <section className={`finish-filters-modal__filter-section`}>
                                {
                                    filters.map((item, idx) => {
                                        return (
                                            <div className={`finish-filters-modal__filter-section-content`} key={idx}>
                                                <h3 className={`finish-filters-modal__filter-section-header`}>{item.filterName}</h3>
                                                <div className={`${!item.nested && "finish-filters-modal__filter-section-grid"}`}>
                                                    {
                                                        !item.nested ?
                                                            <SteelcaseRefinementList 
                                                                key={item.filterName} 
                                                                filterName={item.filterName} 
                                                                filterAttr={item.filterAttr} 
                                                                count={count}
                                                                showHeading={false} 
                                                                searchable={item.searchable} 
                                                                limit={item.limit} 
                                                                sort={item.sort}
                                                                pinnedItems={item.pinnedItems}
                                                                sortItems={item.sortItems}
                                                                sortItemCriteria={item.sortItemCriteria}
                                                                placeholderText={item.placeholderText} 
                                                                setApplyCount={handleSelectedItemsCount} 
                                                                isMobile={isMobile}
                                                            />
                                                        :
                                                            item.nestedAttrs && 
                                                                item.nestedAttrs.map((nestedFilter) => {
                                                                    return (
                                                                        <div key={`${item.filterName}-${nestedFilter.filterName}`}>
                                                                            <p className={"finish-filters-modal__nested-filter"}>{nestedFilter.filterName} <i className={"finish-filters-modal__nested-filter-icon"}>&#9432;</i></p>
                                                                            <div className={"finish-filters-modal__filter-section-grid"}>
                                                                                <SteelcaseRefinementList
                                                                                    key={`${item.filterName}-${nestedFilter.filterName}`} 
                                                                                    filterName={`${item.filterName}-${nestedFilter.filterName}`} 
                                                                                    filterAttr={nestedFilter.filterAttr} 
                                                                                    count={count} 
                                                                                    showHeading={false}
                                                                                    searchable={item.searchable} 
                                                                                    limit={nestedFilter.limit}
                                                                                    sort={item.sort}
                                                                                    pinnedItems={nestedFilter.pinnedItems}
                                                                                    sortItems={nestedFilter.sortItems}
                                                                                    sortItemCriteria={nestedFilter.sortItemCriteria}
                                                                                    placeholderText={item.placeholderText} 
                                                                                    setApplyCount={handleSelectedItemsCount} 
                                                                                    isMobile={isMobile} 
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </section>
                        </div>
                        <div className={"finish-filters--flex finish-filters-modal__filter-section-footer"}>
                                <button
                                    className={"finish-filters__button finish-filters__button--primary"}
                                    onClick={(event) => handleApplyAllFilters(event)}
                                >
                                    {window.steelcase_i18n['steelcase-finish-library'].filters.apply || "Apply"} { selectedItemsCount && selectedItemsCount > 0 ? `${selectedItemsCount}+ ${window.steelcase_i18n["steelcase-finish-library"].materials || "MATERIALS"}` : ""}
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}